import { render, staticRenderFns } from "./UpdateOi.vue?vue&type=template&id=58ef8958&"
import script from "./UpdateOi.vue?vue&type=script&lang=js&"
export * from "./UpdateOi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports